import React, { useState } from 'react';

import { Button, Card, CardBody, CardFooter, Form } from 'reactstrap';

import Checkbox from 'components/shared/Checkbox';
import EmailAddress from 'components/shared/EmailAddress';
import Password from 'components/shared/Password';

import { DEMO_EMAIL } from 'appConstants';
import { LoginModel, loginSchema } from 'models/LoginModel';

import { useAppDispatch, useAppSelector } from 'hooks/hooks';
import { alertActions } from 'reducers/alert.slice';
import { login } from 'services/auth.service';

import DataAlert from 'components/shared/DataAlert';

import { Navigate } from 'react-router-dom';
import * as yup from 'yup';
import { setDemoUser } from '../../reducers/auth.slice';
import { setDemoCustomer } from '../../reducers/customer.slice';


const Login = () => {
    const [loginModel, setLoginModel] = useState<LoginModel>({ email: "", password: "", rememberMe: false, errors: false });
    const user = useAppSelector(x => x.authentication.user);
    const [emailErrors, setEmailErrors] = useState<boolean>(false);
    const [passwordErrors, setPasswordErrors] = useState<boolean>(false);
    const [step, setStep] = useState<string>("email");
    const dispatch = useAppDispatch();

    if (user) {
        return <Navigate to='/alliance/dashboard' />;
    }
    
    const emailSchema = yup.string().required().email();
    
    const handleChange = (propName: string, value: string | boolean) => {
        setLoginModel({ ...loginModel, [propName]: value });
    };

    const submitLogin = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (step === "email") {
            const isValid = await emailSchema.isValid(loginModel.email);
            setEmailErrors(!isValid);
            if (isValid) {
                if (loginModel.email === DEMO_EMAIL) {
                    dispatch(setDemoUser());
                    dispatch(setDemoCustomer());
                    setStep("demo");
                }
                else if (loginModel.email.includes("@bcdinc.com") && process.env.NODE_ENV !== 'development') {
                    if (process.env.REACT_APP_CentralExternalLogin)
                        window.location.href = process.env.REACT_APP_CentralExternalLogin;
                }
                else {
                    setStep("password");
                }
            }
        } else {
            const isValid = await loginSchema.isValid(loginModel);

            setPasswordErrors(!isValid);
            if (isValid) {
                dispatch(alertActions.clear());
                await dispatch(login(loginModel));
            }
        }
    };

    const renderStep = (currentStep: string) => {
        switch (currentStep) {
            case "email":
                return (
                    <EmailAddress email={loginModel.email} errors={emailErrors} propertyName="email" onFieldChange={handleChange} />
                );
            case "password":
                return (
                    <>
                        <Password password={loginModel.password} errors={passwordErrors} propertyName="password" onFieldChange={handleChange} />
                        <Checkbox checked={loginModel.rememberMe} propertyName="rememberMe" label="Remember me?" onFieldChange={handleChange} />
                    </>
                );
            case "demo":
                return (
                    <Navigate to='/alliance/dashboard' />
                );
            default:
                return (
                    <div>I'm lost</div>
                );
        }
    }

    const renderFooter = (currentStep: string) => {
        switch (currentStep) {
            case "email":
                return (
                    <>
                        Need an account?
                        <a href="https://central.bcdvideo.com/Account/register" className="btn-link">Register here</a>
                    </>
                );
            case "password":
                return (
                        <a href="https://central.bcdvideo.com/Account/ForgotPassword" className="btn-link">Forgot your password?</a>
                );
            default:
                return null;
        }
    }

    return (
        <div className="bcd-login-background">
            <div className="d-flex h-100">
                <Form onSubmit={submitLogin} className="m-auto">
                    <Card>
                        <CardBody>
                            <DataAlert />
                            <div className="central-logo central-logo-login">
                                <img className="mb-2 central-img" src="https://central.bcdvideo.com/images/CentralLogo.png" alt="BCD Central Logo" />
                            </div>
                            <hr />
                            {renderStep(step)}
                    <small className="d-block text-center mt-3">
                        {renderFooter(step)}
                    </small>
                        </CardBody>
                        <CardFooter className="text-end">
                            <Button type="submit" color="primary">
                                {step === "email" ?
                                    "Continue" :
                                    "Log In"
                                }
                            </Button>
                        </CardFooter>
                    </Card>
                </Form>
            </div>
        </div>
    );
}

export default Login;